module.exports = __webpack_public_path__ + "img/晴间多云.e20f9d71.png";